import React, { useEffect, useState } from "react";
import Text from "theme/Text";
import i18n from "utils/i18n";
import Button from 'theme/Button'
import CacheStorage from 'utils/cache/CacheStorage'
import ThemedBlock from 'components/atoms/ThemedBlock'
import HelperString from 'utils/helper-string'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const CacheTab = () => {
	const [ cacheSize, setCacheSize ] = useState( '...' );
	
	useEffect( () => {
		CacheStorage.calculateCacheStorage( true ).then( ( result ) => {
			setCacheSize( result );
		});
	}, []);
	
	const clearCache = () => {
		CacheStorage.clearCache();
	}
	
	return (
		<VStack
			space={ ThemedValues.stackSpace }>
			
			<ThemedBlock
				key={ HelperString.hash( "cache-explanation" ) }
				mediumPadding
				shadow>
				
				<Text>{ i18n.t( 'pages.more.settings.cache.explanation' ) }</Text>
			</ThemedBlock>
			<ThemedBlock
				key={ HelperString.hash( "cache-button-container" ) }
				mediumPadding
				shadow>
				
				<Button
					onPress={ clearCache }
					size={ "small" }>
					
					{ `${ i18n.t('buttons.cache_clear') } (${cacheSize})` }
				</Button>
			</ThemedBlock>
		</VStack>
	)
}

export default CacheTab;
